export function ExploreTab() {
  return (
    <section>
      <header className="mb-2 border-b border-border pb-2">
        <h3 className="text-lg font-semibold tracking-tight">Explore</h3>
      </header>
      <p className="mb-6 text-sm text-muted-foreground">Explore and analyze experiment data in depth.</p>
      <div className="flex items-center justify-center h-48 text-muted-foreground"></div>
    </section>
  );
}
